





























import { Component, Vue } from 'vue-property-decorator';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { setCookieSeenTutorialToTrue } from '@/utils/cookie';
Vue.use(VueYouTubeEmbed);

@Component({
  components: {},
})
export default class VideoTutorial extends Vue {
  videoId = 'c5CdIWC_QgI';

  get imageSrc() {
    return require(`@/assets/image/img_home_bg.svg`);
  }

  get currentDomain() {
    return window.location.hostname || '';
  }

  playingEvent() {
    this.$sendMpEvent({
      event: this.$mp_value.VideoPlay,
      properties: { video: this.videoId },
    });
    setCookieSeenTutorialToTrue();
  }
  endedEvent() {
    this.$sendMpEvent({
      event: this.$mp_value.VideoEnd,
      properties: { video: this.videoId },
    });
  }
  errorEvent(error: any) {
    this.$sendMpEvent({
      event: this.$mp_value.VideoError,
      properties: {
        error: error && error.data,
        video: this.videoId,
      },
    });
    setCookieSeenTutorialToTrue();
  }
}
